export default __webpack_public_path__ + "static/media/Lato-Bold.636be8de.ttf";